// this is an autogenerated file from App/Account/Content/Settings/Content/Leads/Content/Content/Questions/Content/Editor/mutation-upsert-question.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Leads_Content_Content_Questions_Content_Editor($question: leads_questions_insert_input!) {
  insert_leads_questions_one(
    object: $question
    on_conflict: {
      constraint: questions_pkey
      update_columns: [
        name
        prompt
        subprompt
        type
        options
        order
        required
        status
        depends_on
        resource_id
        resource_schema
        resource_table
      ]
    }
  ) {
    id
    name
    prompt
    subprompt
    type
    options
    order
    required
    status
    depends_on
    external_resource
    resource_id
    resource_schema
    resource_table
  }
}

`